export const translations = {
    uz: {
        // Header & Navigation
        header: {
            aboutCompany: 'Kompaniya haqida',
            manufacturers: 'Ishlab chiqaruvchilar',
            discounts: 'Chegirmalar',
            news: 'Yangiliklar',
            articles: 'Maqolalar',
            reviews: 'Sharhlar',
            serviceCenter: 'Servis markazi',
            contact: 'Aloqa',
            faqs: 'Ko\'p so\'raladigan savollar',
            menu: 'Menu',
            catalog: 'Katalog',
            search: 'Qidiruv...',
            workingHours: 'Ish kunlari 9:00-18:00',
            loading: 'Yuklanmoqda...',
            noCatalog: 'Katalog bo\'sh',
            searchCatalog: 'Kategoriya qidirish...',
            viewAllProducts: 'Barcha mahsulotlarni ko\'rish',
            noResults: 'bo\'yicha topilmadi',
        },

        // Categories
        categories: {
            analytical: 'Analitik uskunalar',
            testing: 'Sinov uskunalari',
            medical: 'Tibbiy uskunalar',
            furniture: 'Laboratoriya mebeli',
            consumables: 'Sarflanadigan materiallar',
        },

        // Footer
        footer: {
            aboutUs: 'Biz haqimizda',
            forCustomers: 'Mijozlarga',
            howToBuy: 'Qanday xarid qilish',
            requirements: 'Talablar',
            warranty: 'Kafolatlar',
            delivery: 'Yetkazib berish',
            serviceInfo: 'Servis xizmati',
            privacyPolicy: "Maxfiylik siyosati",
            deliveryTerms: "Yetkazib berish shartlari",
            paymentMethods: "To'lov usullari",
            techSupport: "Texnik qo'llab-quvvatlash",
            copyright: 'Copyright © 2025 TexLab. Barcha huquqlar himoyalangan.',
        },

        // Shop Page
        shop: {
            title: 'Mahsulotlar',
            products: 'Mahsulotlar',
            productsFound: 'ta mahsulot topildi',
            categories: 'KATEGORIYALAR',
            brands: 'BRENDLAR',
            all: 'Barchasi',
            sorting: 'Saralash',
            sortBy: 'Tartib',
            newest: 'Eng yangi',
            aToZ: 'A-Z',
            zToA: 'Z-A',
            clearFilters: 'Filtrlarni tozalash',
            resetFilters: 'Filtrlarni tozalash',
            loading: 'Yuklanmoqda...',
            noProductsFound: 'Mahsulot topilmadi',
            notFound: 'Mahsulot topilmadi',
            tryDifferentFilters: 'Boshqa filtrlar yoki kalit sozlarni sinab koring',
            tryOtherFilters: 'Boshqa filtrlar yoki kalit so\'zlarni sinab ko\'ring',
            sendRequest: 'Batafsil',
            previous: 'Orqaga',
            next: 'Oldinga',
            back: 'Orqaga',
            productCode: 'Kod',
            inStock: 'Sotuvda mavjud',
            showAll: 'Barchasini ko\'rish',
            search: 'Qidiruv',
            filters: 'Filtrlar',
            searchPlaceholder: 'Qidirish...',
        },

        // Product Detail Page
        product: {
            home: 'Bosh sahifa',
            description: 'Tavsif',
            brand: 'Brend',
            category: 'Kategoriya',
            recentlyViewed: 'Siz avvalroq ko\'rgan mahsulotlar',
            backToCatalog: 'Katalogga qaytish',
            productNotFound: 'Mahsulot topilmadi',
        },

        // Modal & Forms
        modal: {
            title: 'So\'rov yuborish',
            fullName: 'Ismingiz',
            phone: 'Telefon',
            message: 'Xabar',
            send: 'Yuborish',
            successTitle: 'Muvaffaqiyatli yuborildi!',
            successMessage: 'Tez orada siz bilan bog\'lanamiz',
            required: '*',
            error: 'Xatolik yuz berdi. Iltimos qayta urinib ko\'ring.',
        },

        // Breadcrumb
        breadcrumb: {
            home: 'Bosh sahifa',
            shop: 'Katalog',
            catalog: 'Katalog',
            about: 'Biz haqimizda',
        },

        // Language
        language: {
            uz: "O'zbek tili",
            ru: 'Rus tili',
            languageLabel: 'TILI',
        },

        // HomePage
        home: {
            order: 'Buyurtma berish',
            orderDesc: 'Har qanday uskunani buyurtma asosida yetkazib berish',
            delivery: 'Yetkazib berish',
            deliveryDesc: 'Qo\'shimcha tolossiz to\'g\'ri sizga yetkazamiz',
            warranty: 'Kafolat',
            warrantyDesc: 'Ishonch bilan xarid qiling - hamma narsaga 1 yillik kafolat',
            assortment: 'Keng assortiment',
            assortmentDesc: 'Katalog yangi uskunalar bilan muntazam yangilanadi',
            brands: 'Brendlar',
            newsSection: 'Yangiliklar',
            allNews: 'Barcha yangiliklar',
            news: 'Yangiliklar',
            aboutSection: 'Biz haqimizda',
            clients: 'Bizning mijozlar',
            category: 'Yangiliklar',
            date: 'Sana',
            laboratoryEquipment: 'LABORATORIYA USKUNALARI',
            orderBasis: 'Har qanday uskunani buyurtma asosida yetkazib berish.',
            safelyBuy: 'Xavfsiz xarid qiling!',
            alwaysReady: 'Biz sizga har doim yordam berishga tayyormiz!',
            viewAll: "Barchasini ko'rish",
            new: 'Yangi',
            request: 'So\'rov yuborish',
        },

        // About Page - Additional translations
        about: {
            values: 'Bizning qiymatlarimiz',
            mission: 'Missiya',
            missionDesc: 'Yog\'i laboratoriya uskunalarini eng yuqori sifatida, arzon narxda va tez yetkazib berishni ta\'minlash.',
            vision: 'Vizyon',
            visionDesc: 'Markaziy Asiyadagi laboratoriya uskunalarining yetakchi yetkazib beruvchi bo\'lish.',
            valuesTitle: 'Qiymatlar',
            valuesDesc: 'Sifat, ishonch, halollik va mijozga mas\'uliyat - bu bizning asosiy tamoyillarimiz.',
            whyChooseUs: 'Nima uchun bizni tanlaysiz?',
            certification: 'Sertifikatsiya',
            certificationDesc: 'Barcha mahsulotlar xalqaro standartlarga javoban beradi',
            fastDelivery: 'Tez yetkazib berish',
            fastDeliveryDesc: 'Tashkent va viloyatlarga 2-3 kun ichida yetkazamiz',
            competitivePrice: 'Kompetitiv narxlar',
            competitivePriceDesc: 'Bazardagi eng arzon narxlar va chegirmalar',
            continuousSupport: 'Davomli qo\'llab-quvvatlash',
            continuousSupportDesc: 'Sotish keyingi xizmati va konsultatsiya',

            contactUs: 'Biz bilan aloqada qoling',
            address: 'Manzil',
            phone: 'Telefon',
            email: 'Email',
            statistics: 'Statistika',
            yearsExperience: 'Yillik tajriba',
            satisfiedClients: 'Qanoatlangan mijozlar',
            productsDelivered: 'Mahsulotlar',
            partnersCountries: 'Hamkorlar mamlakatlari',
        },

        // News Page
        news: {
            itemsFound: 'maqola topildi',
            readMore: 'Ko\'proq o\'qish',
            backToNews: 'Yangiliklarga qaytish',
            relatedNews: 'Tegishli yangiliklar',
        },

        // Contact Page
        contact: {
            description: 'Biz bilan bog\'laning va sizning savol yoki takliflaringizni yuboring',
            socialMedia: 'Ijtimoiy tarmoqlar',
            sendMessage: 'Xabar yuborish',
            sending: 'Yuborish...',
        },

        // FAQs Page
        faqs: {
            description: 'Tez-tez so\'raladigan savollar va ularning javoblarini bu yerda topishingiz mumkin',
        },
    },
    ru: {
        // Header & Navigation
        header: {
            aboutCompany: 'О компании',
            manufacturers: 'Производители',
            discounts: 'Скидки',
            news: 'Новости',
            articles: 'Статьи',
            reviews: 'Отзывы',
            serviceCenter: 'Сервис-центр',
            contact: 'Контакты',
            faqs: 'Часто задаваемые вопросы',
            menu: 'Меню',
            catalog: 'Каталог',
            search: 'Поиск...',
            workingHours: 'Рабочие дни 9:00-18:00',
            loading: 'Загрузка...',
            noCatalog: 'Каталог пуст',
            searchCatalog: 'Поиск по категориям...',
            viewAllProducts: 'Показать все товары',
            noResults: 'по запросу не найдено',
        },

        // Categories
        categories: {
            analytical: 'Аналитические приборы',
            testing: 'Испытательное оборудование',
            medical: 'Медицинское оборудование',
            furniture: 'Лабораторная мебель',
            consumables: 'Расходные материалы',
        },

        // Footer
        footer: {
            aboutUs: 'О нас',
            forCustomers: 'Для клиентов',
            howToBuy: 'Как купить',
            requirements: 'Требования',
            warranty: 'Гарантия',
            delivery: 'Доставка',
            serviceInfo: 'Сервис',
            privacyPolicy: "Политика конфиденциальности",
            deliveryTerms: "Условия доставки",
            paymentMethods: "Способы оплаты",
            techSupport: "Техническая поддержка",
            copyright: 'Copyright © 2025 TexLab. Все права защищены.',
        },

        // Shop Page
        shop: {
            title: 'Товары',
            products: 'Товары',
            productsFound: 'товаров найдено',
            categories: 'КАТЕГОРИИ',
            brands: 'БРЕНДЫ',
            all: 'Все',
            sorting: 'Сортировка',
            sortBy: 'Сортировка',
            newest: 'Новые',
            aToZ: 'А-Я',
            zToA: 'Я-А',
            clearFilters: 'Очистить фильтры',
            resetFilters: 'Очистить фильтры',
            loading: 'Загрузка...',
            noProductsFound: 'Товары не найдены',
            notFound: 'Товары не найдены',
            tryDifferentFilters: 'Попробуйте другие фильтры или ключевые слова',
            tryOtherFilters: 'Попробуйте другие фильтры или ключевые слова',
            sendRequest: 'Подробнее',
            previous: 'Назад',
            next: 'Далее',
            back: 'Назад',
            productCode: 'Код',
            inStock: 'В наличии',
            showAll: 'Показать все',
            search: 'Поиск',
            filters: 'Фильтры',
            searchPlaceholder: 'Поиск...',
        },

        // Product Detail Page
        product: {
            home: 'Главная',
            description: 'Описание',
            brand: 'Бренд',
            category: 'Категория',
            recentlyViewed: 'Недавно просмотренные товары',
            backToCatalog: 'Вернуться в каталог',
            productNotFound: 'Товар не найден',
        },

        // Modal & Forms
        modal: {
            title: 'Отправить запрос',
            fullName: 'Ваше имя',
            phone: 'Телефон',
            message: 'Сообщение',
            send: 'Отправить',
            successTitle: 'Успешно отправлено!',
            successMessage: 'Мы свяжемся с вами в ближайшее время',
            required: '*',
            error: 'Произошла ошибка. Пожалуйста, попробуйте еще раз.',
        },

        // Breadcrumb
        breadcrumb: {
            home: 'Главная',
            shop: 'Каталог',
            catalog: 'Каталог',
            about: 'О компании',
        },

        // Language
        language: {
            uz: "O'zbek tili",
            ru: 'Русский',
            languageLabel: 'ЯЗЫК',
        },

        // HomePage
        home: {
            order: 'Заказ',
            orderDesc: 'Заказ любого оборудования с доставкой',
            delivery: 'Доставка',
            deliveryDesc: 'Доставляем прямо вам без дополнительных платежей',
            warranty: 'Гарантия',
            warrantyDesc: 'Покупайте с уверенностью - 1 год гарантии на все',
            assortment: 'Широкий ассортимент',
            assortmentDesc: 'Каталог регулярно обновляется новым оборудованием',
            brands: 'Бренды',
            newsSection: 'Новости',
            allNews: 'Все новости',
            news: 'Новости',
            aboutSection: 'О нас',
            clients: 'Наши клиенты',
            category: 'Новости',
            date: 'Дата',
            laboratoryEquipment: 'ЛАБОРАТОРНОЕ ОБОРУДОВАНИЕ',
            orderBasis: 'Любое оборудование доставляется на заказ.',
            safelyBuy: 'Покупайте безопасно!',
            alwaysReady: 'Мы всегда готовы вам помочь!',
            viewAll: "Посмотреть все",
            new: 'Новое',
            request: 'Отправить запрос',
        },

        // About Page - Additional translations
        about: {
            values: 'Наши ценности',
            mission: 'Миссия',
            missionDesc: 'Обеспечить лабораторное оборудование высочайшего качества по доступным ценам с быстрой доставкой.',
            vision: 'Видение',
            visionDesc: 'Стать ведущим поставщиком лабораторного оборудования в Центральной Азии.',
            valuesTitle: 'Ценности',
            valuesDesc: 'Качество, доверие, честность и ответственность перед клиентом - наши основные принципы.',
            whyChooseUs: 'Почему выбирать нас?',
            certification: 'Сертификация',
            certificationDesc: 'Все продукты соответствуют международным стандартам',
            fastDelivery: 'Быстрая доставка',
            fastDeliveryDesc: 'Доставляем в Ташкент и области за 2-3 дня',
            competitivePrice: 'Конкурентные цены',
            competitivePriceDesc: 'Самые доступные цены и скидки на рынке',
            continuousSupport: 'Постоянная поддержка',
            continuousSupportDesc: 'Поддержка и консультация после продажи',

            contactUs: 'Свяжитесь с нами',
            address: 'Адрес',
            phone: 'Телефон',
            email: 'Почта',
            statistics: 'Статистика',
            yearsExperience: 'Лет опыта',
            satisfiedClients: 'Довольных клиентов',
            productsDelivered: 'Товаров',
            partnersCountries: 'Страны партнеров',
        },

        // News Page
        news: {
            itemsFound: 'статей найдено',
            readMore: 'Читать дальше',
            backToNews: 'Вернуться к новостям',
            relatedNews: 'Похожие новости',
        },

        // Contact Page
        contact: {
            description: 'Свяжитесь с нами и отправьте свои вопросы или предложения',
            socialMedia: 'Социальные сети',
            sendMessage: 'Отправить сообщение',
            sending: 'Отправка...',
        },

        // FAQs Page
        faqs: {
            description: 'Найдите ответы на часто задаваемые вопросы здесь',
        }
    }
}

export default translations;